import { render, staticRenderFns } from "./SelectPage.vue?vue&type=template&id=38822c43&"
import script from "./SelectPage.vue?vue&type=script&lang=js&"
export * from "./SelectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports